/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2026
///                                     RXO Inc.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of RXO Inc. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const CompassIcon = ({
  height,
  title = messages.locations.defaultMessage,
  width
}) => (
  <svg
    aria-labelledby="compass-icon"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id="compass-icon">{title}</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 0a8 8 0 100 16 8 8 0 000-16zm0 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 2.25l2.75 5.5H8v1.25H5.25L8 2.25zm0 11.5L5.25 8.25H8V7h2.75L8 13.75z"
      fill="#fff"
    />
  </svg>
);

export default CompassIcon;
